export default __webpack_public_path__ + "static/logo-wealth-04666282fef4bba0db84f1b76b180677.svg";